var e={skeleton:"styles_skeleton__zzZgq"};export{e as default};
